<template>
    <!--  <div style="margin-top:0px;" :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'">-->
    <div style="margin-top:0px;" :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'">
        <Header/>
        <div
            :class="$i18n.locale=='العربية'?'FrameWork__PageWrapper-v8gq48-13 eRmiUC':'FrameWork__PageWrapper-v8gq48-13 obiMX'" :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important; '">
            <section class="style__SpotlightInnerWrap-sc-1qapdh8-0 kKgHVc">
                <div class="spotlight" :style="$i18n.locale == 'العربية' ?'float:right;width:100%;':'float:left;width:100%;'">
                    <div class="style__SpotlightItemStyled-vo40go-0 cDscbW">
                        <figure>
                            <div class=" gatsby-image-wrapper" style="position:relative;overflow:hidden">
                                <div aria-hidden="true" style="width:100%;padding-bottom:49.5%"></div>

                                <picture v-if="this.pagedata"><img
                                              :src="this.serverurl+'/public/pagebanners/'+pagedata.pagebanner"
                                              alt=""
                                              style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>

                                </picture>


                               <!--            <video style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"-->
<!--                   v-if="this.pagedata && this.pagedata.id==51"  width="100%"-->
<!--                   height="100%" autoplay loop>-->
<!--                <source :src="this.serverurl+'/public/pagebanners/scalping.webm'" type="video/webm" style="position:absolute;top:0;left:0;opacity:1;min-width:100%;min-height:100%;object-fit:cover;object-position:center" />-->
<!--                Your browser does not support the video tag.-->
<!--            </video>-->

                            </div>
                        </figure>
                        <div class="spotlight__info" :style="$i18n.locale == 'العربية' ?'float:right;width:100%;padding-left:8%;padding-right:8%':'float:left;margin-left:3%;width:100%;padding-left:8%;padding-right:8%'">
                            <div class="react-reveal"
                                 style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">
                                <div class="style__SectionTitleStyled-d40vxv-0 kcvceY" :style="$i18n.locale == 'العربية' ?'float:right;margin-right:3%;width: 50%;':'float:left;margin-left:3%;width: 50%;'">
                                    <h2 v-if="pagedata" :style="$i18n.locale == 'العربية' ? 'text-align: right;font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important;'">
                                        {{
$i18n.locale == 'en' ? pagedata.page_entitle : $i18n.locale == 'العربية' ? pagedata.page_artitle : $i18n.locale == '中文' ? pagedata.page_chtitle :$i18n.locale=='Русский'?pagedata.page_rutitle: pagedata.page_frtitle
                                        }}</h2>
                                        <br />

<h3 v-if="pagedata" :style="$i18n.locale == 'العربية' ?'text-align: right;font-size: 23px!important;color:#ffffff;font-family: Cairo,sans-serif !important;margin-right:2%;':'font-size: 23px!important;color:#ffffff;font-family: Comfortaa!important;margin-left:2%'">
                                        {{
                                            $i18n.locale == 'en' ? pagedata.en_subtitle : $i18n.locale == 'العربية' ? pagedata.ar_subtitle : $i18n.locale == '中文' ? pagedata.ch_subtitle :$i18n.locale=='Русский'?pagedata.ru_subtitle: pagedata.fr_subtitle
                                        }}</h3>
                                </div>
                            </div>
                                                       <div class="btn_wrap" :style="$i18n.locale == 'العربية' ?'width:100%;float:right!important;margin-right:3%!important':'width:100%;float:left;margin-left:3%!important'">

                                <div class="react-reveal" :style="$i18n.locale == 'العربية' ?'float:right;animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;':'animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;'">
                                    <div class="style__ButtonWrap-kitu94-0 hqzysg" style="width: 100%!important;text-align: center!important;"><a style=""
                                        href="https://marketequityinc.com/custom/demoaccountlinks.php" target="_blank"
                                        rel="noopener noreferrer"><span>
                                        {{
                                         $i18n.locale == 'en' ? 'Open Demo Account' : $i18n.locale == 'العربية' ? 'فتح حساب تجريبي' : $i18n.locale == '中文' ? '开设模拟账户':$i18n.locale=='Русский'?'Открыть демо-аккаунт' : 'Ouvrir un compte Dé'

                                        }}

                                        </span></a></div>
                                </div>
                                 <div class="react-reveal" :style="$i18n.locale == 'العربية' ?'float:right;animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;':'animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;'">
                                    <div class="style__ButtonWrap-kitu94-0 hqzysg" style="width: 100%!important;text-align: center!important;"><a style=""
                                        href="https://marketequityinc.com/custom/liveaccountlinks.php" target="_blank"
                                        rel="noopener noreferrer"><span>
                                            {{
                                            $i18n.locale == 'en' ? 'Open Live Account' : $i18n.locale == 'العربية' ? 'فتح حساب حقيقي' : $i18n.locale == '中文' ? '开设真实账户':$i18n.locale=='Русский'?'Открыть реальный аккаунт': 'Ouvrir un compte Réel'
                                }}
                                        </span></a></div>
                                </div>
                                <div v-if="pagedata.layout==4" class="react-reveal"
                                     style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 360ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">
                                    <div class="style__ButtonWrap-kitu94-0 hqzysg"><a class="no-border"
                                                                                      href="https://www.linkedin.com/company/market-equity-inc/?originalSubdomain=in"
                                                                                      target="_blank"
                                                                                      rel="noopener noreferrer">
                                        <div class=" gatsby-image-wrapper"
                                             style="position: relative; overflow: hidden; display: inline-block; width: 100px; height: 30px;">
                                            <picture><img loading="lazy" width="100" height="30"
                                                          src="https://dev.marketequityinc.com/public/public/follow-linkedin.jpg"
                                                          alt="Follow us on Linked In"
                                                          style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>
                                            </picture>
                                        </div>
                                    </a></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
<section>

                <div class="FrameWork__ContainerFluidStyled-v8gq48-1 kNCxBo">

                    <div class="FrameWork__ColSm-v8gq48-3 dIoETn">

                        <!-- The Modal -->
                        <div v-if="canview==1" class="modal fade" id="myModal">
                            <div class="modal-dialog modal-lg">
                                <div class="modal-content">

                                    <!-- Modal Header -->
                                    <div class="modal-header" :style="$i18n.locale=='العربية'?'float:left':'float:right'">
                                        <button :style="$i18n.locale=='العربية'?'float:right':'float:left'" type="button" class="close" data-dismiss="modal">&times;</button>
                                    </div>

                                    <!-- Modal body -->
                                    <div class="modal-body">

                                        <form id="register" autocomplete="on">
                                            <div class="form-group row" align="center">

                                                <h4 style="margin-left:2%"  class="modal-title">Register</h4>
                                            </div>
                                            <div class="form-group row">
                                                <label for="inputPassword" class="col-sm-2 col-form-label">
                                                    {{ $i18n.locale == 'العربية' ? 'الإسم' : 'Name' }}

                                                </label>
                                                <div class="col-sm-10">
                                                    <input autocomplete="on" type="text" class="form-control" id="inputPassword"
                                                           v-model="registername">
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label for="staticEmail" class="col-sm-2 col-form-label">{{
                                                        $i18n.locale == 'العربية' ? 'عنوان البريد الالكترونى' : 'Email Address'
                                                    }}</label>
                                                <div class="col-sm-10">
                                                    <input autocomplete="on" type="text" class="form-control" id="inputemail"
                                                           v-model="registeremail">

                                                </div>
                                            </div>
                                            <!--                                    <div class="form-group row">-->
                                            <!--                                        <label for="staticEmail" class="col-sm-2 col-form-label">{{-->
                                            <!--                                                $i18n.locale == 'العربية' ? 'كلمة المرور' : 'Password'-->
                                            <!--                                            }}</label>-->
                                            <!--                                        <div class="col-sm-10">-->
                                            <!--                                            <input type="text" class="form-control" id="inputpasswordr"-->
                                            <!--                                                   v-model="registerpassword" placeholder="Password">-->

                                            <!--                                        </div>-->
                                            <!--                                    </div>-->

                                            <div class="form-group row">
                                                <label for="staticEmail" class="col-sm-2 col-form-label">{{
                                                        $i18n.locale == 'العربية' ? 'الدولة' : 'Country'
                                                    }}</label>
                                                <div class="col-sm-10">

                                                    <select style="height:100%"
                                                            :class="$i18n.locale=='العربية'?'form-control rtlclass':'form-control ltrclass'"
                                                            id="countries" v-model="registercountry" @change="onChange($event)">


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="KW" value="965">
                                                            {{ $i18n.locale == 'العربية' ? 'الكويت' : 'Kuwait' }}
                                                        </option>
                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="DZ" value="213">
                                                            {{ $i18n.locale == 'العربية' ? 'الجزائر' : 'Algeria' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="AD" value="376">
                                                            {{ $i18n.locale == 'العربية' ? 'أندورا' : 'Andorra' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="AI" value="1264">
                                                            {{ $i18n.locale == 'العربية' ? 'أنجويلا' : 'Anguilla' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="AG" value="1268">{{
                                                                $i18n.locale == 'العربية' ? 'أنتيغوا وباربودا' : 'Antigua &amp; Barbuda'
                                                            }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="AR" value="54">
                                                            {{ $i18n.locale == 'العربية' ? 'الأرجنتين' : 'Argentina' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="AM" value="374">
                                                            {{ $i18n.locale == 'العربية' ? 'أرمينيا' : 'Armenia' }}
                                                        </option>
                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="AW" value="297">
                                                            {{ $i18n.locale == 'العربية' ? 'أرمينيا' : 'Aruba' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="AU" value="61">
                                                            {{ $i18n.locale == 'العربية' ? 'أستراليا' : 'Australia' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="AT" value="43">
                                                            {{ $i18n.locale == 'العربية' ? 'النمسا' : 'Austria' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="AZ" value="994">
                                                            {{ $i18n.locale == 'العربية' ? 'أذربيجان' : 'Azerbaijan' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="BS" value="1242">
                                                            {{ $i18n.locale == 'العربية' ? 'باهاماس' : 'Bahamas' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="BH" value="973">
                                                            {{ $i18n.locale == 'العربية' ? 'البحرين' : 'Bahrain' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="BD" value="880">
                                                            {{ $i18n.locale == 'العربية' ? 'بنجلاديش' : 'Bangladesh' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="BB" value="1246">
                                                            {{ $i18n.locale == 'العربية' ? 'باربادوس' : 'Barbados' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="BY" value="375">
                                                            {{ $i18n.locale == 'العربية' ? 'بيلاروس' : 'Belarus' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="BE" value="32">
                                                            {{ $i18n.locale == 'العربية' ? 'بلجيكا' : 'Belgium' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="BZ" value="501">
                                                            {{ $i18n.locale == 'العربية' ? 'بيليز' : 'Belize' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="BJ" value="229">
                                                            {{ $i18n.locale == 'العربية' ? 'بنين' : 'Benin' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="DZ" value="1441">
                                                            {{ $i18n.locale == 'العربية' ? 'برمودا' : 'Bermuda' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="975" value="975">
                                                            {{ $i18n.locale == 'العربية' ? 'بوتان' : 'Bhutan' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="BO" value="591">
                                                            {{ $i18n.locale == 'العربية' ? 'بوليفيا' : 'Bolivia' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="DZ" value="213">{{
                                                                $i18n.locale == 'العربية' ? 'البوسنة والهرسك' : 'Bosnia Herzegovina'
                                                            }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="BW" value="267">
                                                            {{ $i18n.locale == 'العربية' ? 'بوتسوانا' : 'Botswana' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="BR" value="55">
                                                            {{ $i18n.locale == 'العربية' ? 'البرازيل' : 'Brazil' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="DZ" value="213">
                                                            {{ $i18n.locale == 'العربية' ? 'بروناي' : 'Brunei' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="BG" value="359">
                                                            {{ $i18n.locale == 'العربية' ? 'بلغاريا' : 'Bulgaria' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="DZ" value="213">
                                                            {{ $i18n.locale == 'العربية' ? 'بوركينا فاسو ' : 'Burkina Faso' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="BI" value="257">
                                                            {{ $i18n.locale == 'العربية' ? 'بوروندي' : 'Burundi' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="KH" value="855">
                                                            {{ $i18n.locale == 'العربية' ? 'بوروندي' : 'Cambodia' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="CM" value="237">
                                                            {{ $i18n.locale == 'العربية' ? 'كاميرون' : 'Cameroon' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="CA" value="1">
                                                            {{ $i18n.locale == 'العربية' ? 'كندا' : 'Canada' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="DZ" value="238">{{
                                                                $i18n.locale == 'العربية' ? 'الرأس الأخضر' : 'Cape Verde Islands'
                                                            }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="DZ" value="1345">
                                                            {{ $i18n.locale == 'العربية' ? 'جزر كايمان' : 'Cayman Islands' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="CF" value="236">{{
                                                                $i18n.locale == 'العربية' ? 'جمهورية أفريقيا الوسطى' : 'Central African Republic'
                                                            }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="CL" value="56">
                                                            {{ $i18n.locale == 'العربية' ? 'تشيلي' : 'Chile' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="CN" value="86">
                                                            {{ $i18n.locale == 'العربية' ? 'الصين' : 'China' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="CO" value="57">
                                                            {{ $i18n.locale == 'العربية' ? 'كولومبيا' : 'Colombia' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="KM" value="269">
                                                            {{ $i18n.locale == 'العربية' ? 'جزر القمر' : 'Comoros' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="DZ" value="242">
                                                            {{ $i18n.locale == 'العربية' ? 'جمهورية الكونغو' : 'Congo' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="CK" value="682">
                                                            {{ $i18n.locale == 'العربية' ? 'جزر كوك' : 'Cook Islands' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="CR" value="506">
                                                            {{ $i18n.locale == 'العربية' ? 'كوستاريكا' : 'Costa Rica' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="HR" value="385">
                                                            {{ $i18n.locale == 'العربية' ? 'كرواتيا' : 'Croatia' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="CU" value="53">
                                                            {{ $i18n.locale == 'العربية' ? 'كوبا' : 'Cuba' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="CY" value="90392">
                                                            {{ $i18n.locale == 'العربية' ? 'قبرص' : 'Cyprus North' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="CZ" value="42">{{
                                                                $i18n.locale == 'العربية' ? 'جمهورية التشيك' : 'Czech Republic'
                                                            }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="DK" value="45">
                                                            {{ $i18n.locale == 'العربية' ? 'الدنمارك' : 'Denmark' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="DJ" value="253">
                                                            {{ $i18n.locale == 'العربية' ? 'جيبوتي' : 'Djibouti' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="DM" value="1809">
                                                            {{ $i18n.locale == 'العربية' ? 'دومينيكا' : 'Dominica' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="DO" value="1809">{{
                                                                $i18n.locale == 'العربية' ? 'جمهورية الدومينيكان' : 'Dominican Republic'
                                                            }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="EC" value="593">
                                                            {{ $i18n.locale == 'العربية' ? 'الإكوادور' : 'Ecuador' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="EG" value="20">
                                                            {{ $i18n.locale == 'العربية' ? 'مصر' : 'Egypt' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="SV" value="213">
                                                            {{ $i18n.locale == 'العربية' ? 'السلفادور' : 'El Salvador' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="GQ" value="240">{{
                                                                $i18n.locale == 'العربية' ? 'غينيا الاستوائية ' : 'Equatorial Guinea'
                                                            }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="ER" value="213">
                                                            {{ $i18n.locale == 'العربية' ? 'إريتريا' : 'Eritrea' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="EE" value="372">
                                                            {{ $i18n.locale == 'العربية' ? 'إستونيا' : 'Estonia' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="ET" value="251">
                                                            {{ $i18n.locale == 'العربية' ? 'إثيوبيا' : 'Ethiopia' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="FK" value="500">
                                                            {{ $i18n.locale == 'العربية' ? 'جزر فوكلاند' : 'Falkland Islands' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="FO" value="298">
                                                            {{ $i18n.locale == 'العربية' ? 'جزر فارو' : 'Faroe Islands' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="FJ" value="679">
                                                            {{ $i18n.locale == 'العربية' ? 'فيجي' : 'Fiji' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="FI" value="358">
                                                            {{ $i18n.locale == 'العربية' ? 'فنلندا' : 'Finland' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="FR" value="33">
                                                            {{ $i18n.locale == 'العربية' ? 'فرنسا' : 'France' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="GF" value="594">
                                                            {{ $i18n.locale == 'العربية' ? 'غينيا الفرنسية' : 'French Guiana' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="PF" value="689">{{
                                                                $i18n.locale == 'العربية' ? 'بولينيزيا الفرنسية' : 'French Polynesia'
                                                            }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="GA" value="241">
                                                            {{ $i18n.locale == 'العربية' ? 'الغابون' : 'Gabon' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="GM" value="220">
                                                            {{ $i18n.locale == 'العربية' ? 'غامبيا' : 'Gambia' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="GE" value="7880">
                                                            {{ $i18n.locale == 'العربية' ? 'جورجيا' : 'Georgia' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="DE" value="49">
                                                            {{ $i18n.locale == 'العربية' ? 'ألمانيا' : 'Germany' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="GH" value="233">
                                                            {{ $i18n.locale == 'العربية' ? 'غانا' : 'Ghana' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="GR" value="30">
                                                            {{ $i18n.locale == 'العربية' ? 'اليونان' : 'Greece' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="GL" value="299">
                                                            {{ $i18n.locale == 'العربية' ? 'جرينلاند' : 'Greenland' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="GD" value="1473">
                                                            {{ $i18n.locale == 'العربية' ? 'غرينادا' : 'Grenada' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="GP" value="590">
                                                            {{ $i18n.locale == 'العربية' ? 'غوادلوب' : 'Guadeloupe' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="GU" value="671">
                                                            {{ $i18n.locale == 'العربية' ? 'غوام' : 'Guam' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="DZ" value="502">
                                                            {{ $i18n.locale == 'العربية' ? 'غواتيمال' : 'Guatemala' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="GN" value="224">
                                                            {{ $i18n.locale == 'العربية' ? 'غينيا' : 'Guinea' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="GW" value="245">
                                                            {{ $i18n.locale == 'العربية' ? 'غينيا بيساو' : 'Guinea - Bissau' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="GY" value="592">
                                                            {{ $i18n.locale == 'العربية' ? 'غيانا' : 'Guyana' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="HT" value="509">
                                                            {{ $i18n.locale == 'العربية' ? 'هايتي' : 'Haiti' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="HN" value="504">
                                                            {{ $i18n.locale == 'العربية' ? 'هندوراس' : 'Honduras' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="HK" value="852">
                                                            {{ $i18n.locale == 'العربية' ? 'هونج كونج' : 'Hong Kong' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="HU" value="36">
                                                            {{ $i18n.locale == 'العربية' ? 'المجر' : 'Hungary' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="IS" value="354">
                                                            {{ $i18n.locale == 'العربية' ? 'أيسلندا' : 'Iceland' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="IN" value="91">
                                                            {{ $i18n.locale == 'العربية' ? 'الهند' : 'India' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="ID" value="62">
                                                            {{ $i18n.locale == 'العربية' ? 'اندونيسيا' : 'Indonesia' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="IR" value="98">
                                                            {{ $i18n.locale == 'العربية' ? 'ايران' : 'Iran' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="IQ" value="964">
                                                            {{ $i18n.locale == 'العربية' ? 'العراق' : 'Iraq' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="IE" value="353">
                                                            {{ $i18n.locale == 'العربية' ? 'جمهورية أيرلندا ' : 'Ireland' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="IL" value="972">
                                                            {{ $i18n.locale == 'العربية' ? 'إسرائيل' : 'Israel' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="IT" value="39">
                                                            {{ $i18n.locale == 'العربية' ? 'إيطاليا' : 'Italy' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="JM" value="1876">
                                                            {{ $i18n.locale == 'العربية' ? 'جامايكا' : 'Jamaica' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="JP" value="81">
                                                            {{ $i18n.locale == 'العربية' ? 'اليابان' : 'Japan' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="JO" value="962">
                                                            {{ $i18n.locale == 'العربية' ? 'الأردن' : 'Jordan' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="KZ" value="7">
                                                            {{ $i18n.locale == 'العربية' ? 'كازاخستان' : 'Kazakhstan' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="KE" value="254">
                                                            {{ $i18n.locale == 'العربية' ? 'كينيا' : 'Kenya' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="KI" value="686">
                                                            {{ $i18n.locale == 'العربية' ? 'كيريباتي' : 'Kiribati' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="KP" value="850">
                                                            {{ $i18n.locale == 'العربية' ? 'كوريا الشمالية' : 'Korea North' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="KR" value="82">
                                                            {{ $i18n.locale == 'العربية' ? 'كوريا الجنوبية ' : 'Korea South' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="KG" value="996">
                                                            {{ $i18n.locale == 'العربية' ? 'قيرغيزستان' : 'Kyrgyzstan' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="LA" value="856">
                                                            {{ $i18n.locale == 'العربية' ? 'لاوس' : 'Laos' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="LV" value="371">
                                                            {{ $i18n.locale == 'العربية' ? 'لاتفيا' : 'Latvia' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="LB" value="961">
                                                            {{ $i18n.locale == 'العربية' ? 'لبنان' : 'Lebanon' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="LS" value="266">
                                                            {{ $i18n.locale == 'العربية' ? 'ليسوتو' : 'Lesotho' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="LR" value="231">
                                                            {{ $i18n.locale == 'العربية' ? 'ليبيريا' : 'Liberia' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="LY" value="218">
                                                            {{ $i18n.locale == 'العربية' ? 'ليبيا' : 'Libya' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="LI" value="417">
                                                            {{ $i18n.locale == 'العربية' ? 'ليختنشتاين' : 'Liechtenstein' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="LT" value="370">
                                                            {{ $i18n.locale == 'العربية' ? 'ليتوانيا' : 'Lithuania' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="LU" value="352">
                                                            {{ $i18n.locale == 'العربية' ? 'لوكسمبورغ' : 'Luxembourg' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="MK" value="389">
                                                            {{ $i18n.locale == 'العربية' ? 'مقدونيا الشمالية' : 'Macedonia' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="MG" value="261">
                                                            {{ $i18n.locale == 'العربية' ? 'مدغشقر' : 'Madagascar' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="MW" value="265">
                                                            {{ $i18n.locale == 'العربية' ? 'مدغشقر' : 'Malawi' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="MY" value="60">
                                                            {{ $i18n.locale == 'العربية' ? 'ماليزيا' : 'Malaysia' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="MV" value="960">
                                                            {{ $i18n.locale == 'العربية' ? 'المالديف' : 'Maldives' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="ML" value="223">
                                                            {{ $i18n.locale == 'العربية' ? 'مالي' : 'Mali' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="MT" value="356">
                                                            {{ $i18n.locale == 'العربية' ? 'مالطا' : 'Malta' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="MH" value="692">
                                                            {{ $i18n.locale == 'العربية' ? 'جزر مارشال' : 'Marshall Islands' }}
                                                        </option>
                                                        >

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="MQ" value="596">
                                                            {{ $i18n.locale == 'العربية' ? 'مارتينيك' : 'Martinique' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="MR" value="222">
                                                            {{ $i18n.locale == 'العربية' ? 'موريتانيا' : 'Mauritania' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="YT" value="269">
                                                            {{ $i18n.locale == 'العربية' ? 'مايوت' : 'Mayotte' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="MX" value="52">
                                                            {{ $i18n.locale == 'العربية' ? 'المكسيك' : 'Mexico' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="MD" value="373">
                                                            {{ $i18n.locale == 'العربية' ? 'مولدوفا' : 'Moldova' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="MC" value="377">
                                                            {{ $i18n.locale == 'العربية' ? 'موناكو' : 'Monaco' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="MN" value="976">
                                                            {{ $i18n.locale == 'العربية' ? 'منغوليا' : 'Mongolia' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="MS" value="1664">
                                                            {{ $i18n.locale == 'العربية' ? 'مونتسرات' : 'Montserrat' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="MA" value="212">
                                                            {{ $i18n.locale == 'العربية' ? 'المغرب' : 'Morocco' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="MZ" value="258">
                                                            {{ $i18n.locale == 'العربية' ? 'موزمبيق' : 'Mozambique' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="MN" value="95">
                                                            {{ $i18n.locale == 'العربية' ? 'ميانمار' : 'Myanmar' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="NA" value="264">
                                                            {{ $i18n.locale == 'العربية' ? 'ناميبيا' : 'Namibia' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="NR" value="674">
                                                            {{ $i18n.locale == 'العربية' ? 'ناورو' : 'Nauru' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="NP" value="977">
                                                            {{ $i18n.locale == 'العربية' ? 'نيبال' : 'Nepal' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="NL" value="31">
                                                            {{ $i18n.locale == 'العربية' ? 'هولندا' : 'Netherlands' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="NC" value="687">{{
                                                                $i18n.locale == 'العربية' ? 'كاليدونيا الجديدة ' : 'New Caledonia'
                                                            }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="NZ" value="64">
                                                            {{ $i18n.locale == 'العربية' ? 'نيوزيلندا' : 'New Zealand' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="NI" value="505">
                                                            {{ $i18n.locale == 'العربية' ? 'نيكاراجوا' : 'Nicaragua' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="NE" value="227">
                                                            {{ $i18n.locale == 'العربية' ? 'النيجر' : 'Niger' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="NG" value="234">
                                                            {{ $i18n.locale == 'العربية' ? 'نيجيريا' : 'Nigeria' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="NO" value="47">
                                                            {{ $i18n.locale == 'العربية' ? 'النرويج' : 'Norway' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="OM" value="968">
                                                            {{ $i18n.locale == 'العربية' ? 'عُمان' : 'Oman' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="PW" value="680">
                                                            {{ $i18n.locale == 'العربية' ? 'بالاو' : 'Palau' }}
                                                        </option>
                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="IL" value="972">
                                                            {{ $i18n.locale == 'العربية' ? 'فلسطين' : 'Palestine' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="PA" value="507">
                                                            {{ $i18n.locale == 'العربية' ? 'بنما' : 'Panama' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="PG" value="675">{{
                                                                $i18n.locale == 'العربية' ? 'بابوا غينيا الجديدة' : 'Papua New Guinea'
                                                            }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="PY" value="595">
                                                            {{ $i18n.locale == 'العربية' ? 'باراغواي' : 'Paraguay' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="PE" value="51">
                                                            {{ $i18n.locale == 'العربية' ? 'بيرو' : 'Peru' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="PH" value="63">
                                                            {{ $i18n.locale == 'العربية' ? 'الفلبين' : 'Philippines' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="PL" value="48">
                                                            {{ $i18n.locale == 'العربية' ? 'بولندا' : 'Poland' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="PT" value="351">
                                                            {{ $i18n.locale == 'العربية' ? 'البرتغال' : 'Portugal' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="PR" value="1787">
                                                            {{ $i18n.locale == 'العربية' ? 'بورتوريكو' : 'Puerto Rico' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="QA" value="974">
                                                            {{ $i18n.locale == 'العربية' ? 'قطر' : 'Qatar' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="RE" value="262">
                                                            {{ $i18n.locale == 'العربية' ? 'ريونيون' : 'Reunion' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="RO" value="40">
                                                            {{ $i18n.locale == 'العربية' ? 'رومانيا' : 'Romania' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="RU" value="7">
                                                            {{ $i18n.locale == 'العربية' ? 'روسيا' : 'Russia' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="RW" value="250">
                                                            {{ $i18n.locale == 'العربية' ? 'رواندا' : 'Rwanda' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="SM" value="378">
                                                            {{ $i18n.locale == 'العربية' ? 'سان مارينو' : 'San Marino' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="SA" value="966">
                                                            {{ $i18n.locale == 'العربية' ? 'السعودية' : 'Saudi Arabia' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="SN" value="221">
                                                            {{ $i18n.locale == 'العربية' ? 'السنغال' : 'Senegal' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="CS" value="381">
                                                            {{ $i18n.locale == 'العربية' ? 'صربيا' : 'Serbia' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="SC" value="248">
                                                            {{ $i18n.locale == 'العربية' ? 'سيشل' : 'Seychelles' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="SL" value="232">
                                                            {{ $i18n.locale == 'العربية' ? 'سيراليون' : 'Sierra Leone' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="SG" value="65">
                                                            {{ $i18n.locale == 'العربية' ? 'سنغافورة' : 'Singapore' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="SK" value="421">
                                                            {{ $i18n.locale == 'العربية' ? 'سلوفاكيا' : 'Slovak Republic' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="SI" value="386">
                                                            {{ $i18n.locale == 'العربية' ? 'سلوفينيا' : 'Slovenia' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="SB" value="677">
                                                            {{ $i18n.locale == 'العربية' ? 'جزر سليمان' : 'Solomon Islands' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="SO" value="252">
                                                            {{ $i18n.locale == 'العربية' ? 'الصومال' : 'Somalia' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="ZA" value="27">
                                                            {{ $i18n.locale == 'العربية' ? 'جنوب أفريقيا' : 'South Africa' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="ES" value="34">
                                                            {{ $i18n.locale == 'العربية' ? 'إسبانيا' : 'Spain' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="LK" value="94">
                                                            {{ $i18n.locale == 'العربية' ? 'سريلانكا' : 'Sri Lanka' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="SD" value="249">
                                                            {{ $i18n.locale == 'العربية' ? 'السودان' : 'Sudan' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="SR" value="597">
                                                            {{ $i18n.locale == 'العربية' ? 'سورينام' : 'Suriname' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="SZ" value="268">{{
                                                                $i18n.locale == 'العربية' ? 'سوازيلند (إسواتيني) ' : 'Swaziland'
                                                            }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="SE" value="46">
                                                            {{ $i18n.locale == 'العربية' ? 'السويد' : 'Sweden' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="CH" value="41">
                                                            {{ $i18n.locale == 'العربية' ? 'سويسرا	' : 'Switzerland' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="SI" value="963">
                                                            {{ $i18n.locale == 'العربية' ? 'سوريا' : 'Syria' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="TW" value="886">
                                                            {{ $i18n.locale == 'العربية' ? 'تايوان' : 'Taiwan' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="TH" value="66">
                                                            {{ $i18n.locale == 'العربية' ? 'تايلند' : 'Thailand' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="TG" value="228">
                                                            {{ $i18n.locale == 'العربية' ? 'توغو' : 'Togo' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="TO" value="676">
                                                            {{ $i18n.locale == 'العربية' ? 'تونغا' : 'Tonga' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="TT" value="1868">{{
                                                                $i18n.locale == 'العربية' ? 'ترينيداد وتوباغو ' : 'Trinidad &amp; Tobago'
                                                            }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="TN" value="216">
                                                            {{ $i18n.locale == 'العربية' ? 'تونس' : 'Tunisia' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="TR" value="90">
                                                            {{ $i18n.locale == 'العربية' ? 'تركيا' : 'Turkey' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="TM" value="7">
                                                            {{ $i18n.locale == 'العربية' ? 'تركمانستان' : 'Turkmenistan' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="TM" value="993">
                                                            {{ $i18n.locale == 'العربية' ? 'تركمانستان' : 'Turkmenistan' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="TV" value="688">
                                                            {{ $i18n.locale == 'العربية' ? 'توفالو' : 'Tuvalu' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="UG" value="256">
                                                            {{ $i18n.locale == 'العربية' ? 'أوغندا' : 'Uganda' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="UA" value="380">
                                                            {{ $i18n.locale == 'العربية' ? 'أوكرانيا' : 'Ukraine' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="AE" value="971">{{
                                                                $i18n.locale == 'العربية' ? 'الإمارات' : 'Unitied Arab Emirates'
                                                            }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="UY" value="598">
                                                            {{ $i18n.locale == 'العربية' ? 'أوروغواي' : 'Uruguay' }}
                                                        </option>


                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="UZ" value="7">
                                                            {{ $i18n.locale == 'العربية' ? 'أوزبكستان' : 'Uzbekistan' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="VU" value="678">
                                                            {{ $i18n.locale == 'العربية' ? 'فانواتو' : 'Vanuatu' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="VA" value="379">
                                                            {{ $i18n.locale == 'العربية' ? 'الفاتيكان' : 'Vatican City' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="VE" value="58">
                                                            {{ $i18n.locale == 'العربية' ? 'فنزويلا' : 'Venezuela' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="VN" value="84">
                                                            {{ $i18n.locale == 'العربية' ? 'فيتنام' : 'Vietnam' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="VG" value="84">{{
                                                                $i18n.locale == 'العربية' ? 'جزر العذراء البريطانية' : 'Virgin Islands - British'
                                                            }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="VI" value="84">{{
                                                                $i18n.locale == 'العربية' ? 'جزر العذراء الأمريكية' : 'Virgin Islands - US'
                                                            }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="WF" value="681">{{
                                                                $i18n.locale == 'العربية' ? 'واليس وفوتونا' : 'Wallis &amp; Futuna'
                                                            }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="YE" value="969">
                                                            {{ $i18n.locale == 'العربية' ? 'اليمن الشمال' : 'Yemen (North)' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="YE" value="967">
                                                            {{ $i18n.locale == 'العربية' ? 'اليمن الجنوب' : 'Yemen (South)' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="ZM" value="260">
                                                            {{ $i18n.locale == 'العربية' ? 'زامبيا' : 'Zambia' }}
                                                        </option>

                                                        <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
                                                                data-countryCode="ZW" value="263">
                                                            {{ $i18n.locale == 'العربية' ? 'زيمبابوي' : 'Zimbabwe' }}
                                                        </option>
                                                    </select>

                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label for="mobile" class="col-sm-2 col-form-label">{{
                                                        $i18n.locale == 'العربية' ? 'رقم الهاتف' : 'Mobile'
                                                    }}</label>
                                                <div class="col-sm-10">
                                                    <input type="text" class="form-control" id="inputmobile"
                                                           placeholder="Mobile" v-model="registermobile">

                                                </div>
                                            </div>


                                            <button data-dismiss="modal" @click="register($i18n.locale)" type="button" class="btn btn-primary"
                                            >
                                                {{ $i18n.locale == 'العربية' ? 'التسجيل  ' : 'Register' }}
                                            </button>

                                            If you already have an account, <a @click="showsignin()" href="#">Signin</a> to  see the full content

                                        </form>

                                        <form id="signin" method="POST" style="display: none;" action="">
                                            <div class="form-group row">

                                            <h4 :style="$i18n.locale=='العربية'?'float:right;margin-right:2%':'float:left;margin-left:2%'" class="modal-title">Signin</h4>
                                            </div>

                                            <div class="form-group row">
                                                <label for="staticEmail" class="col-sm-2 col-form-label">{{
                                                        $i18n.locale == 'العربية' ?'عنوان البريد الالكترونى':'Account ID' }}</label>
                                                <div class="col-sm-10">
                                                    <input type="text" class="form-control" id="inputemailsignin" placeholder="Accountid" v-model="signinemail">

                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label for="staticEmail" class="col-sm-2 col-form-label">{{
                                                        $i18n.locale == 'العربية' ? 'عنوان البريد الالكترونى' : 'Email Address'
                                                    }}</label>                                      <div class="col-sm-10">
                                                <input type="text" class="form-control" id="inputPasswordsignin" placeholder="Email ID" v-model="signinpassword">
                                            </div>
                                            </div>




                                            <button  @click="login()" type="button" class="btn btn-primary" data-dismiss="modal">Sign In</button>
                                            If you are a new user, <a @click="showregister()" href="#">Register</a> to  see the full content


                                        </form>

                                    </div>

                                    <!-- Modal footer -->
                                    <div class="modal-footer">
<!--                                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>-->
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="react-reveal"
                             style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">
                            <div class="FrameWork__ContentData-v8gq48-10 ZBsdR"
                                 :style="$i18n.locale == 'العربية' ?'text-align: right':'text-align: left'">
                                <div class="FrameWork__Row-v8gq48-2 VIUMD">
                                    <div class="FrameWork__ColSm-v8gq48-3 dIoETn"
                                         style="padding-left:10%;padding-right:10%">


                                        <h2 style="text-transform: uppercase;font-size: 37px;
line-height: 39px;padding-bottom:1%"  align="center">{{
                                                $i18n.locale == 'en' ? dayname : $i18n.locale == 'العربية' ? daynamear : $i18n.locale == '中文' ? dayname : currency.dayname
                                            }} {{ currentdate }} </h2>

                                        <div class="panel-group" id="accordioncurrency" role="tablist" aria-multiselectable="true"
                                             :style="$i18n.locale=='العربية'?'direction:rtl':'direction:left'" >
                                            <div v-for="currency in currencydata" v-bind:key="currency.id"
                                                 class="panel panel-default" style="border:0px!important">
                                                <div style=" border: 0px solid #c3c3c3;"
                                                     :style="$i18n.locale=='العربية'?'float:right;width:100%;text-align:right;direction:rtl':''"
                                                     class="panel-heading" role="tab" id="headingOnecurrency" v-if="$i18n.locale == 'en' && currency.contenten || $i18n.locale == 'العربية' &&  currency.contentar || $i18n.locale == '中文' && currency.contentch || $i18n.locale == 'Français' && currency.titlefr" >
                                                    <h4 class="panel-title">

                                                        <a  role="button" data-toggle="collapse" data-parent="#accordioncurrency"
                                                            :href="'#collapse'+currency.id"
                                                            :aria-expanded="currency.id==accordianid?true:false"
                                                        >



                                                            <img  :style="$i18n.locale == 'العربية' ? 'margin-top: -5px;float:right!important;width:40px;height:35px;border-radius: 50%;margin-left:1%!important;margin-right:1%!important':'margin-top: -5px;float:left!important;width:40px;height:35px;border-radius: 50%;margin-left:1%!important;margin-right:1%!important'" :src="serverurl+'/public/currencybanners/'+currency.bgimage"/>

                                                                                                                      <span :style="$i18n.locale == 'العربية' ? 'text-align: right;font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important;'"> {{

                                                                $i18n.locale == 'en' ? currency.titleen : $i18n.locale == 'العربية' ? currency.titlear : $i18n.locale == '中文' ? currency.titlech : currency.titlefr
                                                            }}
                                                            </span>
                                                             <span :style="$i18n.locale == 'العربية' ? 'font-weight: 150;color:#404040;font-size: 14px;margin-left: 10px;margin-right: 10px;text-align: right;font-family: Cairo,sans-serif !important;' :'font-weight: 150;color:#404040;font-size: 14px;margin-left: 10px;margin-right: 10px;font-family: Comfortaa!important;'"

  >
  {{
                                                                $i18n.locale == 'en' ? currency.descriptionen : $i18n.locale == 'العربية' ? currency.descriptionar : $i18n.locale == '中文' ? currency.descriptionch : currency.descriptionfr
                                                            }}</span>

                                                            <span dir="rtl" lang="ar" :style="$i18n.locale=='العربية'?'margin-top: 0.5%;float:left;font-size:15px;margin-right:4%;text-align: center;direction:rtl':'margin-top: 0.5%;float:right;font-size:15px;margin-right:4%;text-align: center;direction:ltr'" >
                                                                {{

                                                                $i18n.locale == 'en' ? 'View Details' : $i18n.locale == 'العربية' ? 'عرض التفاصيل' : $i18n.locale == '中文' ?  'View Details' :  'View Details'
                                                            }} <i class="fa fa-angle-down" style="margin-left:5px;margin-right:5px;font-size:1.266em;color:#005060"></i>
</span>


                                                        </a>
                                                    </h4>
                                                </div>
                                                <div  :id="'collapse'+currency.id"
                                                      :class="accordianid==currency.id ?'panel-collapse in collapse show':'panel-collapse in collapse'"
                                                      role="tabpanel" aria-labelledby="headingOnefaq">



                                                    <img style="padding-left:2%;padding-right:2%;padding-top:2%;padding-bottom:2%;"  v-if="currency.video_only==0" class="alignnone size-full wp-image-48749"
                                                         :src="serverurl+'/public/currencycharts/'+currency.chart"
                                                         alt=""

                                                         sizes="(max-width: 360px) 350px, (max-width: 767px) 765px, 1002px"
                                                         width="1002" height="535"/>


                                                    <div style="text-align: justify"
                                                        v-html="$i18n.locale == 'en' ? currency.contenten : $i18n.locale == 'العربية' ? currency.contentar : $i18n.locale == '中文' ? currency.contentch : currency.contentfr">

                                                        {{ $i18n.locale == 'en' ? currency.contenten : $i18n.locale == 'العربية' ? currency.contentar : $i18n.locale == '中文' ? currency.contentch : currency.contentfr }}

                                                    </div>
                                                </div>
                                            </div>


                                        </div>


                                        <!--                                        <p style="color:green" v-if="successregiter"> {{ successregiter }}</p>-->
<!--                                        <p style="color:red" v-if="errorregiter"> {{ errorregiter }}</p>-->
<br />
                                        <center><h2 style="font-size: 37px; font-weight: 500; text-transform: uppercase;padding-bottom: 2%;padding-top: 1%">{{ $i18n.locale == 'العربية' ? 'الكروس ' : 'Crosses' }} {{ currentdate }}</h2>

                                        </center>
                                        <div class="panel-group" id="accordioncurrency" role="tablist" aria-multiselectable="true"
                                             :style="$i18n.locale=='العربية'?'direction:rtl':'direction:left'" >
                                            <div v-for="crosses in crossesdata" v-bind:key="crosses.id"
                                                 class="panel panel-default" style="border:0px!important">
                                                <div style=" border: 0px solid #c3c3c3;"
                                                     :style="$i18n.locale=='العربية'?'float:right;width:100%;text-align:right;direction:rtl':''"
                                                     class="panel-heading" role="tab" id="headingOnecurrency" v-if="$i18n.locale == 'en' && crosses.contenten || $i18n.locale == 'العربية' &&  crosses.contentar || $i18n.locale == '中文' && crosses.contentch || $i18n.locale == 'Français' && crosses.titlefr" >
                                                    <h4 class="panel-title">

                                                        <a  role="button" data-toggle="collapse" data-parent="#accordioncurrency"
                                                            :href="'#collapsecross'+crosses.id"
                                                            :aria-expanded="crosses.id==accordianid?true:false"
                                                        >



                                                            <img  :style="$i18n.locale == 'العربية' ? 'margin-top: -5px;float:right!important;width:40px;height:35px;border-radius: 50%;margin-left:1%!important;margin-right:1%!important':'margin-top: -5px;float:left!important;width:40px;height:35px;border-radius: 50%;margin-left:1%!important;margin-right:1%!important'" :src="serverurl+'/public/crossesbanners/'+crosses.bgimage"/>

                                                                                                                      <span :style="$i18n.locale == 'العربية' ? 'text-align: right;font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important;'"> {{

                                                                $i18n.locale == 'en' ? crosses.titleen : $i18n.locale == 'العربية' ? crosses.titlear : $i18n.locale == '中文' ? crosses.titlech : crosses.titlefr
                                                            }}
                                                            </span>
                                                             <span :style="$i18n.locale == 'العربية' ? 'font-weight: 150;color:#404040;font-size: 14px;margin-left: 10px;margin-right: 10px;text-align: right;font-family: Cairo,sans-serif !important;' :'font-weight: 150;color:#404040;font-size: 14px;margin-left: 10px;margin-right: 10px;font-family: Comfortaa!important;'"

  >
  {{
                                                                $i18n.locale == 'en' ? crosses.descriptionen : $i18n.locale == 'العربية' ? crosses.descriptionar : $i18n.locale == '中文' ? crosses.descriptionch : crosses.descriptionfr
                                                            }}</span>

                                                            <span dir="rtl" lang="ar" :style="$i18n.locale=='العربية'?'margin-top: 0.5%;float:left;font-size:15px;margin-right:4%;text-align: center;direction:rtl':'margin-top: 0.5%;float:right;font-size:15px;margin-right:4%;text-align: center;direction:ltr'" >
                                                                {{

                                                                $i18n.locale == 'en' ? 'View Details' : $i18n.locale == 'العربية' ? 'عرض التفاصيل' : $i18n.locale == '中文' ?  'View Details' :  'View Details'
                                                            }} <i class="fa fa-angle-down" style="margin-left:5px;margin-right:5px;font-size:1.266em;color:#005060"></i>
</span>


                                                        </a>
                                                    </h4>
                                                </div>
                                                <div  :id="'collapsecross'+crosses.id"
                                                      :class="accordianid==crosses.id ?'panel-collapse in collapse show':'panel-collapse in collapse'"
                                                      role="tabpanel" aria-labelledby="headingOnecurrency">



                                                    <img style="padding-left:2%;padding-right:2%;padding-top:2%;padding-bottom:2%;"  v-if="crosses.video_only==0 " class="alignnone size-full wp-image-48749"
                                                         :src="serverurl+'/public/crossescharts/'+crosses.chart"
                                                         alt=""

                                                         sizes="(max-width: 360px) 350px, (max-width: 767px) 765px, 1002px"
                                                         width="1002" height="535"/>


                                                    <div style="text-align: justify"
                                                        v-html="$i18n.locale == 'en' ? crosses.contenten : $i18n.locale == 'العربية' ? crosses.contentar : $i18n.locale == '中文' ? crosses.contentch : crosses.contentfr">

                                                        {{ $i18n.locale == 'en' ? crosses.contenten : $i18n.locale == 'العربية' ? crosses.contentar : $i18n.locale == '中文' ? crosses.contentch : crosses.contentfr }}

                                                    </div>
                                                </div>
                                            </div>


                                        </div>


                                    </div>
                                </div>
                            </div>


                    </div>

                </div>

                </div>
            </section>


            <iframe style="display: none; position: fixed; border: 0px none; overflow: hidden;"
                    src="https://marketequity.ladesk.com/scripts/generateWidget.php?v=5.21.17.15&amp;t=1607084151&amp;cwid=e00b30c6&amp;cwrt=C&amp;cwt=chat&amp;pt=Home%20page%20-%20Market%20Equity%20Inc%20-%20Leading%20Trading%20Service%20Provider&amp;ref=https%3A%2F%2Fmarketequity.com%2Fen%2F%23speciality"
                    allowfullscreen="true" allow="microphone; camera" tabindex="-1" class="i-embedded-chat"
                    id="icb_e00b30c6_305"></iframe>


            <Footer/>
        </div>

    </div>

</template>

<script>
import Header from '@/components/header.vue'
import Footer from '@/components/footer.vue'

export default {
    name: 'webinar',
    data() {
        return {

            pagedata: '',
            pageblocksdata: '',
            contactdata: '',
            contractcat: '',
            contractspecdetails: '',
            pagenameroute: '',
            upcomingwebinar: '',
            webinarsprevious: '',
            registeremail: '',
            registername: '',
            registermobile: '',
            registercountry: '965',
            prevregistercountry: '965',
            registerpassword: '',

            prevregisteremail: '',
            prevregistername: '',
            prevregistermobile: '',
            prevregisterpassword: '',
            signinemail: '',
            signinpassword: '',
            subscribeerror: null,
            exampleModalCenter: '',
            prevvideoregister: '',
            webinarid: '',
            prevwebinarid: '',
            successregiter: '',
            errorregiter: '',
            prevuserlogin: '',
            prevpassword: '',
            prevsigninemail: '',
            prevsiginpassword: '',
            prevvideosigninflag: false,
            langchange: '',
            webinarpageregisterflag: false,
            webregisteremail: '',
            webregistermobile: '',
            webregistername: '',
            webregisterlanuage: '',
            registererror: null,
            registercountryname: 'Kuwait',
            currencydata: '',
            crossesdata: '',
            showmodal:false,
            canview:0,
            accordianid:'',
            noregisterflag:0,
            currentdate: '',
            dayname: '',
            daynamear: '',



        }
    },
    components: {
        Header,
        Footer
    },
    mounted() {

        let recaptchaScript = document.createElement('script')
        recaptchaScript.setAttribute('src', 'https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/js/bootstrap.min.js')
        document.head.appendChild(recaptchaScript)
    },
    beforeMount() {
        if (document.cookie != "") {
            var cookies = document.cookie.split(";");
            for (var i = 0; i < cookies.length; i++) {
                var cookie = cookies[i].trim().split("=");

                if (cookie[0] == 'registername') {
                    this.registername = cookie[1];
                }
                if (cookie[0] == 'registermobile') {
                    this.registermobile = cookie[1];
                }
                if (cookie[0] == 'registeremail') {
                    this.registeremail = cookie[1];
                }
                if (cookie[0] == 'registercountry') {
                    this.registercountry = cookie[1];
                }
            }

        }
        if (localStorage.getItem('prevuserlogin') == 1) {
            this.prevuserlogin = 1;
        }
        if (localStorage.getItem('webinarpageregisterflag')) {
            this.webinarpageregisterflag = true;
            // alert(this.webinarpageregisterflag)
        }

        var pathvalues = (this.$route.path).split("/");


        if (pathvalues[1] == 'ar') {
            this.$i18n.locale = 'العربية';
        }
        if (pathvalues[1] == 'ch') {
            this.$i18n.locale = '中文';
        }
        if (pathvalues[1] == 'fr') {
            this.$i18n.locale = 'Français';
        }
        this.langchange = this.$i18n.locale;
        this.pagenameroute = pathvalues[4];
        this.loadpagedata(pathvalues[2]);

    },

    methods: {
        setaccordianid(accordionidvar,noregisterflag){
            this.accordianid=accordionidvar;
            this.noregisterflag=noregisterflag
            if(this.webinarpageregisterflag=='false') {
                if (this.noregisterflag == 0) {
                    this.canview = 1;

                } else {
                    this.canview = 0;
                }
            }
            return;
        },
        setcrossesaccordianid(accordionidvar,noregisterflag){
            this.accordianid=accordionidvar;
            this.noregisterflag=noregisterflag
            if(this.webinarpageregisterflag=='false') {
                if (this.noregisterflag == 0) {
                    this.canview = 1;

                } else {
                    this.canview = 0;
                }
            }
            return;
        },
        showsignin(){
            document.getElementById("signin").style.display = "block";
            document.getElementById("register").style.display = "none";

        },
        showregister(){
            document.getElementById("signin").style.display = "none";
            document.getElementById("register").style.display = "block";

        },

        onChange(event) {
           // var optionValue = event.target.value;
           // var optionText = event.target.options[event.target.options.selectedIndex].text;
            this.registercountryname=event.target.options[event.target.options.selectedIndex].text;
           // alert( this.registercountryname)

        },



        register(langfl) {
            if (!this.registeremail || !this.registermobile || !this.registername) {
                this.registererror = "الرجاء تعبئة جميع البيانات";
                return false;
            }
            this.successregiter = ""
            if (langfl == 'العربية') {
                langfl = 'ar';
            }

            this.langchange = langfl;

            this.$axios.get("registeranalysis", {
                params: {

                    email: this.registeremail,
                    name: this.registername,
                    language: this.langchange,
                    mobile: this.registercountry + this.registermobile,
                    country:this.registercountryname

                }
            })
                .then(res => {
                    if (res) {
                        console.log(res)

                        if (res.data.code == 200) {
                            //  document.getElementById("salesforceregister").submit();

                            this.webinarpageregisterflag = true;
                           // localStorage.setItem('webinaremail', this.registeremail)

                            document.cookie =
                                "registername=" + this.registername + ";" + 2147483647 + ";path=/";
                            document.cookie =
                                "registeremail=" + this.registeremail + ";" + 2147483647 + ";path=/";
                            document.cookie =
                                "registermobile=" + this.registermobile + ";" + 2147483647 + ";path=/";
                            document.cookie =
                                "registercountry=" + this.registercountry + ";" + 2147483647 + ";path=/";

                            // setCookie("FirstName", this.registername);
                            // setCookie("mobile", webinarmobile);
                            if (this.langchange != 'ar') {
                                this.successregiter = "Thank you for register. Please check your inbox";


                            } else {
                                this.webinarpageregisterflag = true;

                                this.successregiter = "شكرا للتسجيل الرجاء التحقق من بريدك الإلكتروني";
                            }
                            this.registeremail = null;
                            this.registername = null;
                            this.webinarid = null;
                            this.registercountry = '965';

                            this.canview=1;


                        } else {
                            this.errorregiter = "Error with Register. Please Register after some time";

                        }


                    }
                });
        },
        login() {
             this.$axios.get("analysislogin", {
                params: {

                    accountnumber: this.signinemail,
                    email: this.signinpassword,


                }
            })
                .then(res => {
                    if (res) {
                        console.log(res)

                        if (res.data.code == 200) {
                            this.canview=1;
                            return false;
                        } else {
                            this.canview=0;

                            this.errorregiter = "User does not Exist. Please Register";
                            return false;
                        }


                    }
                });
        },
        prevsiginmwebinar() {
            if (!this.prevsigninemail || !this.prevsiginpassword) {
                this.errorregiter = "Please Fill all Fields";

                return false;
            }

            this.$axios.get("prevuserlogin", {
                params: {

                    prevemail: this.prevsigninemail,
                    prevpassword: this.prevsiginpassword,


                }
            })
                .then(res => {
                    if (res) {
                        console.log(res)

                        if (res.data.code == 200) {
                            this.prevuserlogin = 1;
                            localStorage.setItem('prevuserlogin', this.prevuserlogin)
                            this.successregiter = "Thank you for Signin. Now you can watch the videos";
                            return false;
                        } else {
                            this.prevuserlogin = 0;

                            this.errorregiter = "Your Username / Password Wrong";
                            return false;
                        }


                    }
                });
        },

        loadpagedata(pagename) {

            this.$axios.get("loadpagedata", {
                params: {
                    pagename: pagename
                }
            })
                .then(res => {
                    if (res) {
                        console.log(res)
                        this.pagedata = res.data.pagedata[0];
                        this.currencydata = res.data.currencydata;
                        this.crossesdata = res.data.crossdata;
                        this.currentdate = res.data.currentdate;
                        this.dayname = res.data.dayname;
                        this.daynamear = res.data.daynamear;

                    }
                });


        },
    }
}
</script>

<style>

.rtlclass {
    direction: rtl !important;
    font-family: Cairo,sans-serif !important;


}

.ltrclass {
    direction: ltr !important;
}

select {
    width: 150px;
    line-height: 49px;
    height: 38px;
    font-size: 22px;
    outline: 0;
    margin-bottom: 15px;
}

.p {
    animation-fill-mode: both;
    animation-duration: 1000ms;
    animation-delay: 0ms;
    animation-iteration-count: 1;
    opacity: 1;
    animation-name: slideInUp;
}


.modal-backdrop {
    opacity: 0.5 !important;
}
#accordionfaq .panel {
    border: none;
    border-radius: 3px;
    box-shadow: none;
    margin-bottom: 0px;
}

#accordionfaq .panel-heading {
    padding: 0;
    border: none;
    border-radius: 3px;
}

#accordionfaq .panel-title a {
    display: block;
    padding: 8px 8px 8px 8px;
    background: #ffffff;
    border: 1px solid #c3c3c3;
    border-radius: 3px;
    font-size: 22px;
    font-weight: bold;
    color: #005060;
    text-shadow: 0px 0px 0px #fff;
    position: relative;

}

#accordionfaq .panel-title a p {
    margin-bottom: 11px !important;
    margin-left: 10px !important;
    margin-right: 10px !important;
}

#accordionfaq .panel-collapse div p {
    margin-bottom: 11px !important;
    margin-left: 10px !important;
    margin-right: 10px !important;

}

#accordionfaq .panel-collapse div {
    background-color: #ffffff!important;
    border-top: 1px solid #ffffff!important;
    border-bottom: 1px solid #ffffff!important;
    border-left: 1px solid #ffffff!important;
    border-right: 1px solid #ffffff!important;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 10px;
    padding-bottom: 10px;

}


#accordioncurrency .panel {
    border: none;
    border-radius: 3px;
    box-shadow: none;
    margin-bottom: 0px;
}

#accordioncurrency .panel-heading {
    padding: 0;
    border: none;
    border-radius: 3px;
}

#accordioncurrency .panel-title a {
    display: block;
    padding: 8px 8px 8px 8px;
    background: #ffffff;
    border: 1px solid #c3c3c3;
    border-radius: 3px;
    font-size: 22px;
    font-weight: bold;
    color: #005060;
    text-shadow: 0px 0px 0px #fff;
    position: relative;

}

#accordioncurrency .panel-title a p {
    margin-bottom: 11px !important;
    margin-left: 10px !important;
    margin-right: 10px !important;
}

#accordioncurrency .panel-collapse div p {
    margin-bottom: 11px !important;
    margin-left: 10px !important;
    margin-right: 10px !important;

}

#accordioncurrency .panel-collapse div {
    background-color: #ffffff!important;
    border-top: 1px solid #ffffff!important;
    border-bottom: 1px solid #ffffff!important;
    border-left: 1px solid #ffffff!important;
    border-right: 1px solid #ffffff!important;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 10px;
    padding-bottom: 10px;

}


/*#accordionfaq .panel-title a ::before {*/

/*    content: "+";*/
/*    font-family: "Font Awesome 5 Free";*/
/*    width: 25px;*/
/*    height: 25px;*/
/*    line-height: 25px;*/
/*    border-radius: 50%;*/
/*    background: rgb(45, 174, 202) none repeat scroll 0% 0%;*/
/*    font-size: 12px;*/
/*    font-weight: 900;*/
/*    color: #ffffff;*/
/*    text-align: center;*/
/*    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5);*/
/*    text-shadow: none;*/
/*    position: absolute;*/
/*    top: 8px;*/
/*    right: 15px;*/

/*}*/

.shownone{
    display:none
}
iframe{


width: 100%;

max-width: 560px;
min-height:315px;
}

</style>

